<template>
  <div class="content">
    <h1 class="title">{{ $t("productGroup.title") }}</h1>
    <div>
      <div class="table">
        <v-data-table
          v-if="!isLoading"
          :headers="tableHeaders"
          :items="productGroups"
          disable-sort
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              @click="handleEdit(item.raw.id)"
              icon="mdi-pencil"
              variant="text"
            ></v-btn>
          </template>
          <template v-slot:no-data>
            <Vue3Lottie
              :animationData="NoDataLottie"
              :height="200"
              :width="200"
            />
            <div class="pb-5 table-no-data">
              <h3>{{ $t("tableNoDataTitle") }}</h3>
              <p>{{ $t("tableNoDataDesc") }}</p>
            </div>
          </template>
          <template v-slot:bottom>
            <div class="botSide">
              <v-row align="center" justify-sm="end" justify="center" class="px-2">
                <v-col cols="12" xs="12" lg="3" md="4" sm="6">
                  <v-row align="center" justify="end"
                    ><div class="pr-2 pageSelectorLabel">
                      {{ $t("anomaly.tableFooterText") }}
                    </div>
                    <v-select
                      v-model="limit"
                      hide-details
                      @update:model-value="handleFilter(false)"
                      :items="pageSizes"
                      class="pageSelector pl-5"
                    ></v-select>
                    <div class="pl-2">
                      {{ displayRange }}
                    </div>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  lg="3"
                  md="4"
                  sm="5"
                  class="pl-1 pr-1 pagination"
                >
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                    rounded="circle"
                    :total-visible="1"
                    show-first-last-page="true"
                    @update:model-value="handleFilter(true)"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
        <v-card v-else class="loading">
          <v-progress-circular
            v-if="isLoading"
            size="73.5"
            indeterminate
            class="loading-circle"
          ></v-progress-circular>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import NoDataLottie from "@/assets/lotties/nodatalottie.json";
import { useToast } from "vue-toastification";
const toast = useToast();
import CreateProductGroupDescModalVue from "@/components/global/modalComponents/createProductGroupDescModal/CreateProductGroupDescModal.vue";
import { mapActions } from "vuex";

export default {
  name: "ProductGroup",
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      NoDataLottie,
      isLoading: false,

      productGroups: undefined,
      languages: undefined,
      description: undefined,

      productDescription: [],

      page: 1,
      total: undefined,
      limit: undefined,

      pageSizes: [10, 25, 50, 100],
    };
  },
  mounted() {
    this.getProductGroups();
    this.getLanguages()
      .then((res) => {
        this.languages = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    ...mapActions({
      productGroupList: "products/productGroupList",
      updatePorductGroup: "products/updatePorductGroup",
      getLanguages: "settings/getLanguages",
    }),

    getProductGroups() {
      this.isLoading = true;

      this.productGroupList()
        .then((response) => {
          this.productGroups = response.list;
          this.total = response.total;
          this.limit = response.limit;

          // Product Description to ProductGroupDescModal
          // Add productDescription array to ProductGroupDescModal ( helperID is the productID )
          this.productDescription = [];
          response.list.forEach((element) => {
            let helperID = null;
            helperID = element.id;

            this.productDescription.push({
              id: helperID,
              product_group_description: element.productgroup_name,
            });
          });

          for (let i = 0; i < response.list.length; i++) {
            response.list[i].productgroup_name.map((item) => {
              if (item.language.code2 === "hu") {
                this.description = item.description;
              } else {
                this.description =
                  response.list[i].productgroup_name[0].description;
              }
            });
            this.productGroups[i].description = this.description;
          }

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    handleEdit(id) {
      this.emitter.emit("showComponentModalModal", {
        bind: {
          is: CreateProductGroupDescModalVue,
          id: id,
          languages: this.languages,
          productDescription: this.productDescription,
        },
        on: {
          saveProductGroup: (datas) => {
            const requestBody = {
              id: datas.id,
              description: datas.message,
              language_id: datas.lang,
            };

            this.isLoading = true;
            this.updatePorductGroup(requestBody)
              .then(() => {
                toast.success(this.$t("productGroup.successSave"));
                this.emitter.emit("closeModal");
                this.getProductGroups();
                this.isLoading = false;
              })
              .catch((e) => {
                console.log(e);
                this.emitter.emit("closeModal");
                this.isLoading = false;
              });
          },
          closeModal: () => {
            this.emitter.emit("closeModal");
          },
        },
      });
    },

    handleFilter(hasPage) {
      const requestBody = {
        limit: this.limit,
        page: hasPage ? this.page : 1,
      };

      this.isLoading = true;

      this.productGroupList(requestBody)
        .then((response) => {
          this.productGroups = response.list;

          for (let i = 0; i < response.list.length; i++) {
            response.list[i].productgroup_name.map((item) => {
              if (item.language.code2 === "hu") {
                this.description = item.description;
              } else {
                this.description =
                  response.list[i].productgroup_name[0].description;
              }
            });
            this.productGroups[i].description = this.description;
          }

          this.total = response.total;
          this.limit = response.limit;

          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    displayRange() {
      const start = (this.page - 1) * this.limit + 1;
      const end = Math.min(start + this.limit - 1, this.total);
      return `${start}-${end} of ${this.total}`;
    },
    tableHeaders() {
      return [
        {
          title: this.$t("productGroup.table.headers.id"),
          key: "id",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("productGroup.table.headers.groupName"),
          key: "name",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("productGroup.table.headers.description"),
          key: "description",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("productGroup.table.headers.actions"),
          key: "actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
